const avatarFormEquip = {
  photo: 'FOTO'
};

export default avatarFormEquip;
